
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClosingReason, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ClosingReasonEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    closingReason: ClosingReason;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getClosingReason()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getClosingReason(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.closingReason = data;
                this.onDataChanged.next(this.closingReason);
                resolve(this.closingReason);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('closingReason/' + this.routeParams.id).subscribe((res: ClosingReason ) => {
                    this.closingReason = res;
                    this.onDataChanged.next(this.closingReason);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(closingReason): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('closingReason/', closingReason).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(closingReason): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('closingReason/', closingReason).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(closingReason): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('closingReason/' + closingReason.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): ClosingReason {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
